/**
 * Explanations of shipment security conditions for the AI assistant, shared by the shipment pages.
 * Plain text only: the clauses themselves stay written out at each call site.
 */
export const EXPEDITION_RULE_DESCRIPTION = {
  imported: 'Read-only while the shipment has the Imported status; editable again once the shipment moves to another status',
  importedAction: 'Not offered while the shipment has the Imported status',
  finishedOrCancelled: 'Not offered on a finished or cancelled shipment',
};
